import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const genId = () => Date.now().toString(36) + Math.random().toString(36).slice(2, 5);

export const useTabsStore = create(
  persist(
    (set, get) => ({
      tabs: [],
      activeTabId: null,

      createTab: (name, { items, customer, discount, note }) => {
        const n   = name.trim() || `Cuenta ${get().tabs.length + 1}`;
        const tab = {
          id:        genId(),
          name:      n,
          createdAt: new Date().toISOString(),
          items,
          customer:  customer  ?? null,
          discount:  discount  ?? 0,
          note:      note      ?? '',
        };
        set((s) => ({ tabs: [...s.tabs, tab] }));
        return tab;
      },

      updateTab: (id, { items, customer, discount, note }) =>
        set((s) => ({
          tabs: s.tabs.map((t) =>
            t.id === id
              ? { ...t, items, customer, discount, note }
              : t
          ),
        })),

      closeTab: (id) =>
        set((s) => ({
          tabs:        s.tabs.filter((t) => t.id !== id),
          activeTabId: s.activeTabId === id ? null : s.activeTabId,
        })),

      setActiveTab: (id) => set({ activeTabId: id }),
      clearActiveTab:   () => set({ activeTabId: null }),
    }),
    { name: 'pos-tabs' }
  )
);
